if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      // this.cartNotification = document.querySelector('cart-notification');
    }

    onSubmitHandler(evt) {
      
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();
      // this.cartNotification.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      // formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          // this.cartNotification.renderContents(response);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  }
  customElements.define('product-form',ProductForm);

  if (!customElements.get('multi-product-form')) {
    customElements.define('multi-product-form', class MultiProductForm extends ProductForm {
      constructor() {
        super();
      }
  
      //override submit handler 
      onSubmitHandler(evt) {
        
        evt.preventDefault();
        const submitButton = this.querySelector('[type="submit"]');
        

        if (submitButton.classList.contains('loading')) return;
  
        this.handleErrorMessage();
        // this.cartNotification.setActiveElement(document.activeElement);
  
        submitButton.setAttribute('aria-disabled', true);
        submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
        //mdfy request 
        //comapred to the original product form we are here using json object
        //whereas the original one doens't mention content type
        //passing data without formdata using own get variants method
        // const config = fetchConfig('json');
        // config.headers['X-Requested-With'] = 'XMLHttpRequest';
        
        let items = this.getSelectedVariants();

        console.log({items})
        let body = { 
          "items" : items,
          // "sections" : this.cartNotification.getSectionsToRenderMultiProduct().map((section) => section.id),
          "sections_url" : window.location.pathname

        }

        // config.body = JSON.stringify(body);

        
         
        /* here using add_url with "js" compared to routes.cart_add_url
        to get proper error responses as needed */
        const add_url  = '/cart/add.js';
        fetch(add_url, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify(body)
        })
        .then((response) => {
          document.dispatchEvent(new CustomEvent('cart:build')); 
          document.dispatchEvent(new CustomEvent('cart:open')); 
          return response.json();
          
        })
        .then((response) => {
          
          //cart api adds a status only if there is error
          if (response.status) {
            //console.log(response.errors);
            this.handleErrorMessage(response.description);
            return;
          }
                    
          //console.log(JSON.stringify(response));
          
          
          /* multiple items in cart notification  */
          // this.cartNotification.renderContentsMultiProduct(response);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          handleFloCartBtn();
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          //console.log("in finally");
          
        });  
         


      }
  
      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
  
        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
  
        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    });
  }
}



//mdfy custom variant logic built on top of shopfiy implementation

class MultiVariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {

    //console.log("called on change here");
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    //console.log("string print here "+this.options.toString());
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
    //console.log("string print "+this.options.toString());
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );

    if (!newMedia) return;
    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    const parent = newMedia.parentElement;
    if (parent.firstChild == newMedia) return;
    modalContent.prepend(newMediaModal);
    parent.prepend(newMedia);
    this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
    if(this.stickyHeader) {
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }
    window.setTimeout(() => {
      parent.scrollLeft = 0;
      parent.querySelector('li.product__media-item').scrollIntoView({behavior: 'smooth'});
    });
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('multi-variant-selects', MultiVariantSelects);

class MultiVariantRadios extends MultiVariantSelects {
  constructor() {
    super();
    this.variantsChangeEvent = new Event('multiVariantsChange',{
      bubbles: true,
      //cancelable: false,
      //composed: true
    });
    
  }
  //NOTE overridding here
  onVariantChange() {
    //console.log("called this here for variants change in child");
    /* todo temp refer super implementation , using parts of parent as needed */
    //super.onVariantChange();
  
    this.updateOptions();
    this.dispatchEvent(this.variantsChangeEvent);
    

  }

  updateOptions() {
    console.log("update options called");

    
       
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));

 
    this.options = fieldsets.map((fieldset) => {
      let checked_radio = Array.from(fieldset.querySelectorAll('input')).find( (radio)=> {
        //TODO check if can replace with just return radio.checked
        if(radio.checked) { 
          return true;
        }
        return false;

      });

      let obj = {};
      if(checked_radio !== undefined){
        //NOTE this value is not an intger,its a string
        obj.id = checked_radio.value;
        
        //console.log("field gorup message message");
        //console.log(fieldset.dataset.groupMessage);
        /* todo check this assignement for custom data here right ?? */
        obj.msg = fieldset.dataset.groupMessage;
        return obj; 
      }
      return obj;

          
    }).filter ( x => Object.keys(x).length !== 0);
    //For debugging purposes
    /* 
    this.options.forEach( ele => { 
      
      console.log(ele);
    
    });
     */
   
  }
  /* 
    syncs the state of data-last-radio-selected-index with the state of buttons
    this is useful for syncing state when working with bf cache
  */
  syncLastSelectedDataFromState(){



    const fieldsets = Array.from(this.querySelectorAll('fieldset'));

    fieldsets.forEach((fieldset) => { 
      
      let lastRadioSelectedIndex = parseInt(fieldset.dataset.lastRadioSelectedIndex);

      let radios = Array.from(fieldset.querySelectorAll('input'));


      let checked_radio_index = radios.findIndex( (radio)=> {
        //TODO check if can replace with just return radio.checked
        if(radio.checked) { 
          return true;
        }
        return false;
      });

      //console.log("the value of checked_radio_index "+checked_radio_index);
      fieldset.dataset.lastRadioSelectedIndex = checked_radio_index;

    
    });



  }
  //returns the total price of all selections
  getSelectedItemsPriceAndQuantity(){ 

    const selected_variants =  this.getSelectedVariants();
    const variantsData = this.getVariantData();
    //console.log(this);
    //console.log(selected_variants);
    //console.log(variantsData);
    
      

    let selected_price = 0;
    //TODO cmp price if enabled only then need to check this using liquid???
    let selectd_cmp_price = 0;
    let selected_quantity = 0;

    /*
    Note -> Shopify Product ids are 64bit ints -> https://shopify.dev/api/admin-rest/2022-01/resources/product#resource_object
    Javascript cannot parse these big ints -> https://stackoverflow.com/questions/5353388/javascript-parsing-int64
    Nothing is mentioned about variant ids but they are also large ~47-48 bits currently.
    However,shopify is still storing those ids as numbers in there JS logic.
    To keep compatibility with Shopify, we are also keeping them as Numbers(In various json structures).
    However, values from html elements(radio check box values) are converted to strings.
    So to make it easier to work, we are converting Ints to Strings here for comparision 
    rather than the other way arounnd.
    */
    selected_variants.forEach(obj => {
      //get data of the selected variant using ID
      let variant_data = variantsData.find( (variant) => {
        return ( variant.id.toString() === obj.id);
        
      });
      
      //typeof price is number so we can use that without conversion
      selected_price +=variant_data.price;
      selectd_cmp_price +=variant_data.compare_at_price;

    });
    selected_quantity = selected_variants.length;

    return { 
      'selected_price' : selected_price,
      'selectd_cmp_price' : selectd_cmp_price,
      'selected_quantity' : selected_quantity
    };
    
  }
}

customElements.define('multi-variant-radios', MultiVariantRadios);

